import HttpService from './http.service';

class CurrencyRatesService {
  getCurrencies() {
    return HttpService.get('currency_rates/currencies')
      .then((res) => res.data);
  }

  getCurrencyRates(params) {
    return HttpService.get('currency_rates', {
      params,
    })
      .then((res) => res.data);
  }

  getCurrencyRate(id) {
    return HttpService.get(`currency_rates/${id}`)
      .then((res) => res.data);
  }

  parseCurrencies(params) {
    return HttpService.get('currency_rates/parse', {
      params,
    })
      .then((res) => res.data);
  }

  createCurrencyRate(currencyRate) {
    return HttpService.post('currency_rates', currencyRate)
      .then((res) => res.data);
  }

  updateCurrencyRate(currencyRate) {
    return HttpService.patch(`currency_rates/${currencyRate.id}`, currencyRate)
      .then((res) => res.data);
  }

  deleteCurrencyRate(currencyRate) {
    return HttpService.delete(`currency_rates/${currencyRate.id}`)
      .then((res) => res.data);
  }
}

export default new CurrencyRatesService();
